@if (isDashboardLoading) {
  <div class="loader-position-standart-black loader-background"></div>
}
<div [style.display]="!isDashboardLoading ? '' : 'none'" class="mobile-margin-top max-limit" [ngClass]="!isMobile ? 'dashboard-container mt-4' : 'row'">
  <div class="dashboard-container-left">
    <small class="current-date">{{currentDate }}</small>
    @if (!isMerckTenant) {
      <h2 [ngClass]="!isMobile ? 'welcome-text' : 'mt-3'" ><span class="welcome-heading">Willkommen, {{userName}}!</span></h2>
    }
    @if (!isMerckTenant) {
      <div id="dashboard-welcome-container" class="welcome-container">
        <p><span id="dashboard-welcome-message" class="welcome-message">Wir freuen uns sehr, Sie bei uns begrüßen zu dürfen! Die Anmeldung
          war der erste Schritt, um Ihre Infrastrukturverwaltung in ein smartes Assetmanagement zu verwandeln! Wir haben
          eine Vielzahl von Funktionen für Sie vorbereitet, um Ihren Arbeitsalltag so einfach wie möglich zu gestalten.
          Sollten Sie Anregungen oder Fragen haben, kontaktieren Sie uns jederzeit – wir stehen Ihnen gerne zur Seite und
        unterstützen Sie bei der Arbeit!</span></p>
        <p><span class="regards-message">Viele Grüße,</span></p>
        <p><span class="team-signature">Das Team von ing+</span></p>
      </div>
    }
    <div class="notifications-widget-container" [ngClass]="!isMobile && isMerckTenant ? 'welcome-text' : 'mt-3'" >
      <app-notifications-dashboard (isLoading)="isNotificationsLoading = $event"></app-notifications-dashboard>
    </div>
  </div>
  <div class="dashboard-container-right">
    <!--Announcement widget-->
    @if (!isMerckTenant) {
      <div [ngClass]="!isMobile ? 'mb-4' : 'mb-3'" class="announcements-widget-container">
        <div class="w-100">
          <app-announcement-widget (isLoading)="isAnnouncementsLoading = $event" class="announcements-widget"></app-announcement-widget>
        </div>
      </div>
    }
    <div class="d-grid widgets-grid" [class.single-column]="isMerckTenant" [ngClass]="!isMobile ? 'mb-4 gap-4' : 'mb-3 gap-3'">
      <div class="weather-widget-container" [style]="isMerckTenant ? 'order:1' : 'order:2'">
        <app-weather-widget (isLoading)="isWeatherLoading = $event"></app-weather-widget>
      </div>
      <!--User Event widget / Niederschlag widget (Merck)-->
      @if (isMerckTenant) {
        <app-niederschlag-widget class="niederschlag-widget" (isLoading)="isNiederschlagLoading = $event"></app-niederschlag-widget>
      } @else {
        <app-events-widget (isLoading)="isEventsLoading = $event"></app-events-widget>
      }

    </div>
    <!--Feedback widget-->
    @if (!isMerckTenant) {
      <div class="feedback-widget-container">
        <div>
          <app-feedback-widget class="feedback-widget"></app-feedback-widget>
        </div>
      </div>
    }
  </div>
</div>
